import { mount } from 'svelte';
import { registerSW } from 'virtual:pwa-register';
import App from './App.svelte';

// Register the service worker so the app works offline-first.
registerSW({ immediate: true });

const app = mount(App, {
	target: document.body
});

export default app;